import { render, staticRenderFns } from "./DatasetLabel.vue?vue&type=template&id=c1448cb6&scoped=true&"
import script from "./DatasetLabel.vue?vue&type=script&lang=js&"
export * from "./DatasetLabel.vue?vue&type=script&lang=js&"
import style0 from "./DatasetLabel.vue?vue&type=style&index=0&id=c1448cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1448cb6",
  null
  
)

export default component.exports